//fonts
import "./fonts/Lato-Regular.eot";
import "./fonts/Lato-Regular.ttf";
import "./fonts/Lato-Regular.woff";
import "./fonts/Lato-Regular.woff2";
import "./fonts/Montserrat-Regular.eot";
import "./fonts/Montserrat-Regular.ttf";
import "./fonts/Montserrat-Regular.woff";
import "./fonts/Montserrat-Regular.woff2";
import "./fonts/Poppins-Regular.eot";
import "./fonts/Poppins-Regular.ttf";
import "./fonts/Poppins-Regular.woff";
import "./fonts/Poppins-Regular.woff2";
import "./fonts/Manrope-Regular.eot";
import "./fonts/Manrope-Regular.ttf";
import "./fonts/Manrope-Regular.woff";
import "./fonts/Manrope-Regular.woff2";
// javaScript
import "./scripts/search-box";
import "./scripts/search-results";
import "./scripts/font-awesome";
import "bootstrap";
import "./scripts/app";
import "./scripts/carousel-slider";
import "./scripts/lists";
import "./scripts/hide-taxonomies";
import "./scripts/navigation";
import "./scripts/image-gallery-slider";
import "./scripts/share";
import "./scripts/logos-and-flyers"
import "./vendors/_datatables.min";
import "./scripts/external-data";
import "./scripts/award-selected";
import "./scripts/in-page-nav";
import "./scripts/utils";
//import "./scripts/table-paging"; //Disabled temporarily
// IMAGES
import "./images/broker-customers.jpg";
import "./images/businesswomen.jpg";
import "./images/adult-commerce.jpg";
import "./images/capitus.png";
import "./images/brunette.jpg";
import "./images/logo-background.png";
import "./images/jw.jpg";
import "./images/law.jpg";
import "./images/logo-white.png";
import "./images/parking.jpg";
import "./images/logo-staff.png";
import "./images/logo-sm.svg";
import "./images/ara_favicon.svg";
import "./images/realtors_favicon.png";
import "./images/ara-logo-a-sq.png"
import "./images/original/aerial-architecture-blue-sky-466685.jpg";
import "./images/original/adult-black-boardroom-1345085.jpg";
// JSON 


//("use strict");
//if (process.env.NODE_ENV === "development") {
//    addBrowserSyncScript();
//}

//function addBrowserSyncScript() {
//    var browserSyncScript = document.createElement("script");
//    browserSyncScript.setAttribute("id", "__bs_script__");
//    browserSyncScript.innerHTML =
//        "//<![CDATA[" +
//        "\n" +
//        'document.write("<script async src=\'http://HOST:3000/browser-sync/browser-sync-client.js?v=2.26.3\'></script>".replace("HOST", location.hostname));' +
//        "\n" +
//        "//]]>";

//    document.body.appendChild(browserSyncScript);
//}

// eslint-disable-line semi